"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var CheckIcon_1 = __importDefault(require("../../widgets/CheckIcon"));
var useStyles = core_1.makeStyles(function (theme) {
    return core_1.createStyles({
        uncheckedIcon: {
            width: '20px',
            height: '20px',
            borderRadius: '2px',
            border: "solid 1px " + theme.palette.primary.main,
        },
        filled: {
            backgroundColor: theme.palette.primary.main,
            display: 'flex',
            alignItems: 'center',
            justifyContents: 'center',
        },
        icon: {
            width: '20px',
            display: 'flex',
            marginLeft: '-1px',
            filter: 'invert(100%)',
        },
    });
});
exports.default = (function (_a) {
    var checked = _a.checked, className = _a.className, onClick = _a.onClick;
    var classes = useStyles();
    return (react_1.default.createElement(core_1.IconButton, { className: className, onClick: onClick }, checked ? (react_1.default.createElement("div", { className: classes.uncheckedIcon + " " + classes.filled },
        react_1.default.createElement(CheckIcon_1.default, { color: "#fff" }))) : (react_1.default.createElement("div", { className: classes.uncheckedIcon }))));
});
